import { render, staticRenderFns } from "./CompareCenterButton.vue?vue&type=template&id=13da361c"
import script from "./CompareCenterButton.vue?vue&type=script&lang=js"
export * from "./CompareCenterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports